import {MutationTree} from "vuex";
import { v4 as uuid } from 'uuid';

export const mutations: MutationTree<any> = {

    addMappingItem(state: any, mappingItem: any) {
        state.mappings.push(mappingItem);
    },

    updateMappingItem(state: any, mappingItem: any) {

        const index = state.mappings.findIndex((item: any) => {
            return parseInt(mappingItem.column.index) === parseInt(item.column.index);
        });

        if (index === null) {
            throw new Error("Could not locate mapping item");
        }

        state.mappings.splice(index,1, JSON.parse(JSON.stringify(mappingItem)));
    },

    clearMappings(state: any) {
        state.mappings = [];
    },

    setStepperModel(state: any, stepperModel: any) {
        state.stepperModel = stepperModel;
    },

    setFileInspectorDone(state: any, bool: boolean) {
        state.fileInspectorDone = bool;
    },

    setColumnMapperDone(state: any, bool: boolean) {
        state.columnMapperDone = bool;
    },

    setUploaderDone(state: any, bool: boolean) {
        state.uploaderDone = bool;
    },

    resetComponents(state: any) {
        state.fileInspectorKey = uuid();
        state.columnMapperKey = uuid();
        state.uploaderKey = uuid();
        state.resultsKey = uuid();
    }
};
